module.exports = __webpack_public_path__ + "img/background_c4-1-2_mobile.c2c861f1.jpg";